import { ApiContext, apiContextFetch } from "@/hooks/api/base"
import type { SequenceEnrollmentsResponse } from "@/hooks/api/sequence-enrollments/api"

export function fetchHouseholdSequenceEnrollments(context: ApiContext, householdId: string) {
  return apiContextFetch<SequenceEnrollmentsResponse>(context, `households/${householdId}/sequence_enrollments`)
}
